<template>
  <div class="mt-3 mb-4 breadcrumbs">
    <div class="breadcrumb__prepend">
      <div class="breadcrumb__item" v-for="(item, index) in breadcrumbs" :key="index">
        <span :class="{
          '--disabled': item.disabled,
          '--link': item.meta && item.meta.value,
          '--active': item.active}"
          @click="breadcrumbClicked(item)"
        >
          {{item.title}}
        </span>
        <span v-if="index + 1 < breadcrumbs.length " class="breadcrumb__item__separator">{{separator}}</span>
      </div>
    </div>
    <div class="breadcrumb__item--after">
      <slot name="breadcrumbAfter"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    },
    separator: {
      type: String,
      required: false,
      default: '·'
    }
  },
  methods: {
    breadcrumbClicked: function (breadcrumb) {
      if (!breadcrumb.meta || !breadcrumb.meta.value) return
      if (typeof breadcrumb.meta.value === 'function') {
        breadcrumb.meta.value()
      } else if (typeof breadcrumb.meta.type === 'string') {
        console.log(breadcrumb.meta.value)
        this.$router.push(breadcrumb.meta.value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin for-desktop {
  @media (min-width: 599px) {
    @content;
  }
}
.breadcrumbs {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  & .breadcrumb__prepend {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
    flex-grow: 2;
    @include for-desktop {
      flex-direction: row;
    }
    & .breadcrumb__item {
      margin-right: 0.15rem;
      font-size: 0.9rem;
      font-weight: bold;
      color: #d4d4d4;
      &:last-of-type {
        color: #29c4a9;
        font-size: 1.1rem;
      }
      & .--link {
        &:hover {
          cursor: pointer;
          color: #6e6e6e;
        }
      }
      // & .--active-appointments {
      //   color: #29c4a9;
      // }
      & .breadcrumb__item__separator {
        margin-left: 0rem;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
  & .breadcrumb__item {
    &--after > :not(.disabled){
        &:hover {
          cursor: pointer !important;
        }
      }
  }
}
</style>
